import { useRef, useEffect } from "react";

function useInterval({ callback, delay, isActive = true }) {
  const savedCallback = useRef(callback);
  const intervalRef = useRef(null)

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  const cancelInterval = () => clearInterval(intervalRef.current)

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      if (isActive)
        intervalRef.current = setInterval(tick, delay);
      else
        clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [delay, isActive]);

  return [cancelInterval]
}

export default useInterval;
